import React, { useState, Fragment } from 'react'
import Button from '../Button'
import { Dialog, Transition } from '@headlessui/react'

function ScheduleModal({ isOpen, setIsOpen }) {
  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog 
        as="div" 
        className="relative z-50" 
        onClose={() => setIsOpen(false)}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-70" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center text-center p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-[calc(100%-20px)] sm:w-[580px] md:w-[800px] lg:w-[1000px] xl:w-[1130px] transform">
                <div className="relative w-full h-[550px] sm:h-[600px] md:h-[700px] lg:h-[800px] xl:h-[850px]">
                  <iframe 
                    src="https://api.leadconnectorhq.com/widget/booking/1LipfM3jNUpGo9CehWOm" 
                    className="w-full h-full border-none"
                    scrolling="no"
                    id="Xw0C27hda3EIrsgdBbm5_1739264271721"
                  />
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  )
}

export default function Card14() {
    const card = [
        {
            icon: `<svg xmlns="http://www.w3.org/2000/svg" width="31" height="31" viewBox="0 0 25 24" fill="none">
  <g clipPath="url(#clip0_1_2112)">
    <path d="M12.833 7.50001C13.583 4.53938 16.4157 3.02766 22.583 3.00001C22.6816 2.99963 22.7793 3.01878 22.8705 3.05634C22.9616 3.0939 23.0445 3.14913 23.1142 3.21885C23.1839 3.28856 23.2391 3.37139 23.2767 3.46255C23.3142 3.55372 23.3334 3.65141 23.333 3.75001V17.25C23.333 17.4489 23.254 17.6397 23.1133 17.7803C22.9727 17.921 22.7819 18 22.583 18C16.583 18 14.265 19.2098 12.833 21M12.833 7.50001C12.083 4.53938 9.25036 3.02766 3.08301 3.00001C2.98442 2.99963 2.88672 3.01878 2.79556 3.05634C2.7044 3.0939 2.62157 3.14913 2.55185 3.21885C2.48214 3.28856 2.42691 3.37139 2.38935 3.46255C2.35179 3.55372 2.33264 3.65141 2.33301 3.75001V17.1595C2.33301 17.6227 2.61989 18 3.08301 18C9.08301 18 11.4094 19.2188 12.833 21M12.833 7.50001V21" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </g>
  <defs>
    <clipPath id="clip0_1_2112">
      <rect width="24" height="24" fill="white" transform="translate(0.833008)"/>
    </clipPath>
  </defs>
</svg>`,
            title: 'Train & Scale University',
            p: 'Master offer creation, system building, and virtual team development.',
            list: [
                { li: 'Proprietary Business Building Framework' },
                { li: '7-Figure System Implementation' },
                { li: 'Team Building & Management' },
                { li: 'Strategic Growth Planning' },
            ],
            feature: [
                {
                    title: '98%',
                    p: "Success Rate",
                },
                {
                    title: '30 Days',
                    p: "First Client",
                },
                {
                    title: '14 Days',
                    p: "Implementation",
                },
                {
                    title: 'Lifetime',
                    p: "Support",
                },
            ]
        },
        {
            icon: `<svg xmlns="http://www.w3.org/2000/svg" width="31" height="31" viewBox="0 0 25 24" fill="none">
  <path d="M12.5 3.75C10.312 3.75 8.21354 4.61919 6.66637 6.16637C5.11919 7.71354 4.25 9.81196 4.25 12C4.25 14.188 5.11919 16.2865 6.66637 17.8336C8.21354 19.3808 10.312 20.25 12.5 20.25C14.688 20.25 16.7865 19.3808 18.3336 17.8336C19.8808 16.2865 20.75 14.188 20.75 12C20.75 9.81196 19.8808 7.71354 18.3336 6.16637C16.7865 4.61919 14.688 3.75 12.5 3.75ZM2.75 12C2.75 6.615 7.115 2.25 12.5 2.25C17.885 2.25 22.25 6.615 22.25 12C22.25 17.385 17.885 21.75 12.5 21.75C7.115 21.75 2.75 17.385 2.75 12ZM12.5 7.5C11.3065 7.5 10.1619 7.97411 9.31802 8.81802C8.47411 9.66193 8 10.8065 8 12C8 13.1935 8.47411 14.3381 9.31802 15.182C10.1619 16.0259 11.3065 16.5 12.5 16.5C13.6935 16.5 14.8381 16.0259 15.682 15.182C16.5259 14.3381 17 13.1935 17 12C17 10.8065 16.5259 9.66193 15.682 8.81802C14.8381 7.97411 13.6935 7.5 12.5 7.5ZM6.5 12C6.5 10.4087 7.13214 8.88258 8.25736 7.75736C9.38258 6.63214 10.9087 6 12.5 6C14.0913 6 15.6174 6.63214 16.7426 7.75736C17.8679 8.88258 18.5 10.4087 18.5 12C18.5 13.5913 17.8679 15.1174 16.7426 16.2426C15.6174 17.3679 14.0913 18 12.5 18C10.9087 18 9.38258 17.3679 8.25736 16.2426C7.13214 15.1174 6.5 13.5913 6.5 12ZM10.25 12C10.25 11.4033 10.4871 10.831 10.909 10.409C11.331 9.98705 11.9033 9.75 12.5 9.75C13.0967 9.75 13.669 9.98705 14.091 10.409C14.5129 10.831 14.75 11.4033 14.75 12C14.75 12.5967 14.5129 13.169 14.091 13.591C13.669 14.0129 13.0967 14.25 12.5 14.25C11.9033 14.25 11.331 14.0129 10.909 13.591C10.4871 13.169 10.25 12.5967 10.25 12Z" fill="currentColor"/>
</svg>`,
            title: 'Train & Scale Setter Edition',
            p: 'Learn organic outreach strategies to book qualified appointments without ad spend.',
            list: [
                { li: 'High-Ticket Lead Generation' },
                { li: 'Automated Booking Systems' },
                { li: 'Qualification Frameworks' },
                { li: 'Conversion Optimization' },
            ],
            feature: [
                {
                    title: '10.5%',
                    p: "Booking Rate",
                },
                {
                    title: '96%',
                    p: "Lead Quality",
                },
                {
                    title: '25hrs/wk',
                    p: "Time Saved",
                },
                {
                    title: '425%',
                    p: "ROI",
                },
            ]
        },
        {
            icon: `<svg xmlns="http://www.w3.org/2000/svg" width="31" height="31" viewBox="0 0 25 24" fill="none">
  <g clipPath="url(#clip0_1_2224)">
    <path d="M16.4526 6H23.3098V12.8571" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M23.3096 6L13.6239 15.6857C13.4637 15.8428 13.2483 15.9307 13.0239 15.9307C12.7996 15.9307 12.5841 15.8428 12.4239 15.6857L8.48107 11.7429C8.32084 11.5858 8.10543 11.4978 7.88107 11.4978C7.65671 11.4978 7.44129 11.5858 7.28107 11.7429L1.02393 18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </g>
  <defs>
    <clipPath id="clip0_1_2224">
      <rect width="24" height="24" fill="white" transform="translate(0.166992)"/>
    </clipPath>
  </defs>
</svg>`,
            title: 'Train & Scale Closer Edition',
            p: 'Unlock 7-figure sales psychology and methodology refined over 8 years.',
            list: [
                { li: 'Advanced Sales Psychologyrk' },
                { li: 'High-Ticket Closing Scripts' },
                { li: 'Objection Management' },
                { li: 'Deal Structuring' },
            ],
            feature: [
                {
                    title: '33%',
                    p: "Close Rate",
                },
                {
                    title: '$15K+',
                    p: "Avg Deal",
                },
                {
                    title: '30hrs/wk',
                    p: "TIME SAVED",
                },
                {
                    title: '2.3x',
                    p: "Growth",
                },
            ]
        },
    ]
    const card2 = [
        {
            icon: `<svg width="79" height="79" viewBox="0 0 79 79" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.931152" y="0.507812" width="77.8451" height="77.8451" rx="38.9226" fill="#13AD64"/>
<g clip-path="url(#clip0_43_3459)">
<path d="M23.311 31.6429C23.3114 29.7978 23.7887 27.9841 24.6967 26.3779C25.6047 24.7717 26.9124 23.4274 28.4931 22.4756C30.0737 21.5238 31.8735 20.9967 33.7179 20.9455C35.5623 20.8944 37.3886 21.3208 39.0196 22.1836C40.6505 23.0463 42.0308 24.316 43.0264 25.8694C44.022 27.4228 44.5992 29.2073 44.7019 31.0495C44.8045 32.8917 44.4292 34.7292 43.6124 36.3837C42.7956 38.0381 41.5649 39.4533 40.0399 40.4919C43.324 41.6964 46.1725 43.8562 48.2188 46.6933C50.2651 49.5303 51.4156 52.9148 51.5221 56.4113C51.5176 56.7882 51.3675 57.1489 51.1034 57.4178C50.8392 57.6868 50.4813 57.8433 50.1045 57.8546C49.7277 57.8659 49.361 57.7311 49.0812 57.4785C48.8014 57.2258 48.63 56.8748 48.6029 56.4988C48.487 52.7067 46.8992 49.1087 44.1758 46.4673C41.4525 43.8259 37.8076 42.3487 34.0138 42.3487C30.2199 42.3487 26.5751 43.8259 23.8517 46.4673C21.1284 49.1087 19.5405 52.7067 19.4246 56.4988C19.4051 56.8799 19.2372 57.2383 18.9567 57.497C18.6762 57.7558 18.3055 57.8945 17.9241 57.8833C17.5426 57.8721 17.1807 57.7119 16.9159 57.4371C16.6511 57.1624 16.5045 56.7948 16.5074 56.4132C16.6135 52.9165 17.7638 49.5315 19.8101 46.6941C21.8564 43.8566 24.7051 41.6966 27.9895 40.4919C26.5476 39.5099 25.3676 38.1903 24.5521 36.648C23.7367 35.1057 23.3107 33.3875 23.311 31.6429ZM34.0147 23.8584C31.9502 23.8584 29.9701 24.6785 28.5103 26.1384C27.0504 27.5983 26.2302 29.5783 26.2302 31.6429C26.2302 33.7075 27.0504 35.6875 28.5103 37.1474C29.9701 38.6072 31.9502 39.4274 34.0147 39.4274C36.0793 39.4274 38.0593 38.6072 39.5192 37.1474C40.9791 35.6875 41.7992 33.7075 41.7992 31.6429C41.7992 29.5783 40.9791 27.5983 39.5192 26.1384C38.0593 24.6785 36.0793 23.8584 34.0147 23.8584ZM50.1481 31.6429C49.8614 31.6429 49.5799 31.6623 49.3035 31.7013C49.1106 31.7358 48.9126 31.7311 48.7215 31.6875C48.5304 31.6439 48.3501 31.5623 48.1912 31.4475C48.0324 31.3326 47.8983 31.187 47.7969 31.0192C47.6956 30.8514 47.629 30.665 47.6013 30.4709C47.5736 30.2769 47.5853 30.0793 47.6356 29.8898C47.6859 29.7004 47.7738 29.523 47.8942 29.3683C48.0146 29.2136 48.1648 29.0847 48.3361 28.9893C48.5073 28.894 48.696 28.8341 48.8909 28.8132C50.8265 28.5334 52.8002 28.9051 54.5014 29.8698C56.2025 30.8346 57.5346 32.3376 58.288 34.1423C59.0414 35.9471 59.1733 37.9511 58.6629 39.8391C58.1526 41.727 57.0289 43.3916 55.4688 44.571C57.7621 45.5979 59.7093 47.2664 61.0754 49.3753C62.4415 51.4842 63.1682 53.9433 63.1677 56.456C63.1677 56.8431 63.014 57.2144 62.7402 57.4881C62.4665 57.7618 62.0952 57.9156 61.7081 57.9156C61.321 57.9156 60.9498 57.7618 60.676 57.4881C60.4023 57.2144 60.2485 56.8431 60.2485 56.456C60.2492 54.2842 59.5499 52.17 58.2542 50.427C56.9585 48.684 55.1355 47.405 53.0556 46.7799L52.0164 46.4685V43.2068L52.8143 42.8C53.9971 42.2009 54.9434 41.2207 55.5006 40.0175C56.0577 38.8144 56.1931 37.4587 55.885 36.1691C55.5768 34.8796 54.8431 33.7315 53.8022 32.9102C52.7613 32.089 51.474 31.6425 50.1481 31.6429Z" fill="white"/>
</g>
<defs>
<clipPath id="clip0_43_3459">
<rect width="46.7071" height="46.7071" fill="white" transform="translate(16.5 16.0781)"/>
</clipPath>
</defs>
</svg>

                        `,
            title: '$20M+',
            p: "Revenue Generated",

        },
        {
            icon: `<svg width="79" height="79" viewBox="0 0 79 79" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.362305" y="0.507812" width="77.8451" height="77.8451" rx="38.9226" fill="#4760EC"/>
<path d="M52.9074 43.3215C52.9074 51.106 39.2845 56.9444 39.2845 56.9444C39.2845 56.9444 25.6616 51.106 25.6616 43.3215V25.8063C28.5808 26.1313 35.3923 25.8063 39.2845 21.9141C43.1768 25.8063 49.9882 26.1313 52.9074 25.8063V43.3215Z" stroke="white" stroke-width="2.59484" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
 `,
            title: '8+ Years',
            p: "Proven Experience",

        },
        {
            icon: `<svg width="79" height="79" viewBox="0 0 79 79" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.792969" y="0.507812" width="77.8451" height="77.8451" rx="38.9226" fill="#8D44F1"/>
<path d="M46.4823 41.1602L49.4307 57.7528C49.4637 57.9482 49.4363 58.149 49.3521 58.3284C49.2679 58.5078 49.131 58.6572 48.9596 58.7567C48.7882 58.8561 48.5905 58.9009 48.393 58.8849C48.1955 58.869 48.0076 58.7931 47.8543 58.6675L40.8872 53.4383C40.5508 53.187 40.1423 53.0512 39.7224 53.0512C39.3026 53.0512 38.894 53.187 38.5577 53.4383L31.5789 58.6656C31.4257 58.791 31.238 58.8667 31.0407 58.8827C30.8435 58.8986 30.646 58.854 30.4747 58.7548C30.3035 58.6557 30.1665 58.5066 30.0821 58.3276C29.9977 58.1486 29.97 57.9481 30.0025 57.7528L32.9489 41.1602" stroke="white" stroke-width="2.59484" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M39.7158 43.3223C46.1647 43.3223 51.3926 38.0944 51.3926 31.6455C51.3926 25.1966 46.1647 19.9688 39.7158 19.9688C33.2669 19.9688 28.0391 25.1966 28.0391 31.6455C28.0391 38.0944 33.2669 43.3223 39.7158 43.3223Z" stroke="white" stroke-width="2.59484" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`,
            title: '500+',
            p: "Success Stories",

        },
        {
            icon: `<svg width="79" height="79" viewBox="0 0 79 79" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.224121" y="0.507812" width="77.8451" height="77.8451" rx="38.9226" fill="#E42A61"/>
<path d="M39.1466 21.9141L34.5732 33.1238L22.4878 34.019L31.7514 41.8424L28.8516 53.597L39.1466 47.2137M39.1466 21.9141L43.7201 33.1238L55.8055 34.019L46.5419 41.8424L49.4417 53.597L39.1466 47.2137" stroke="white" stroke-width="2.59484" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

 `,
            title: '98%',
            p: "Client Satisfaction",

        },
    ]
    const [isScheduleOpen, setIsScheduleOpen] = useState(false)
    return (
        <>
            <div className='card14'>
                <div className="common-title max-w-[619px] mx-auto !mb-7">
                    <div className="subtitle">
                        <div className="line"></div>
                        <div className="line"></div>
                        Premium Knowledge Vault
                    </div>
                    <h3>Exclusive Access to Our <span className='text-primary'>Coaching Programs</span></h3>
                    <p className='lg:!text-lg'>Access our battle-tested frameworks and methodologies, refined through years of real-world implementation and millions in generated revenue.</p>
                </div>
                <div className="cards grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3  gap-4 lg:gap-8">
                    {card.map((item, index) => (
                        <div className="single  card h-full" key={index}>
                            <div className="inner rounded-2xl h-full px-4 xl:px-5 py-6 xl:py-8 group hover:bg-gradient-to-l bg-gradient-to-r from-[#E0EDFE] to-[#F2F7FD]">
                                <div className="flex flex-col items-center gap-2 md:gap-3 mb-2 md:mb-3">
                                    <div className="flex-[0_0_auto] flex items-center justify-center size-[52px] xl:size-[62px] rounded-full bg-[#E0EDFE] group-hover:bg-[#2563EB] group-hover:text-white transition-all duration-500">
                                        <div dangerouslySetInnerHTML={{ __html: item.icon }}></div>
                                    </div>
                                    <div className='text-center'>
                                        <h4 className='text-base lg:text-lg xl:text-xl font-medium mb-1 text-[#111827] !leading-[150%]'>{item.title} </h4>
                                        <p className='text-sm'>{item.p} </p>
                                    </div>
                                    <button className='flex items-center justify-center gap-2 border-0 bg-primary rounded-full !text-base lg:!text-lg text-white font-medium py-1 px-3 tracking-[.045px]'>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                                            <path d="M17.3299 10.168H5.22061C4.26522 10.168 3.49072 10.9425 3.49072 11.8979V17.9525C3.49072 18.9079 4.26522 19.6824 5.22061 19.6824H17.3299C18.2852 19.6824 19.0597 18.9079 19.0597 17.9525V11.8979C19.0597 10.9425 18.2852 10.168 17.3299 10.168Z" stroke="white" stroke-width="1.94613" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M6.95068 10.1673V6.70754C6.95068 5.56055 7.40632 4.46054 8.21737 3.6495C9.02841 2.83845 10.1284 2.38281 11.2754 2.38281C12.4224 2.38281 13.5224 2.83845 14.3335 3.6495C15.1445 4.46054 15.6001 5.56055 15.6001 6.70754V10.1673" stroke="white" stroke-width="1.94613" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                        Premium Access
                                    </button>
                                </div>
                                <ul className='flex justify-start flex-col gap-2 md:gap-[10px]'>
                                    {item.list.map((item, index) => (
                                        <li key={index} className='flex items-center gap-[6px] text-sm hover:text-[#2563EB] transition-all duration-500'>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                                                <path d="M12.1673 2.5631L12.2443 2.7161L12.8203 4.2491C12.8653 4.3691 12.9603 4.4651 13.0813 4.5101L14.5613 5.0661C15.2113 5.3091 15.5603 6.0031 15.3873 6.6601L15.3453 6.7901L14.6573 8.3131C14.6311 8.37125 14.6175 8.43431 14.6175 8.4981C14.6175 8.56189 14.6311 8.62495 14.6573 8.6831L15.3113 10.1231C15.4481 10.4249 15.4683 10.7668 15.3678 11.0826C15.2673 11.3984 15.0534 11.6658 14.7673 11.8331L14.6143 11.9101L13.0813 12.4861C13.022 12.5088 12.9682 12.5438 12.9234 12.5888C12.8786 12.6338 12.8438 12.6877 12.8213 12.7471L12.2653 14.2271C12.1489 14.5378 11.9213 14.7943 11.6267 14.9469C11.332 15.0995 10.9912 15.1373 10.6703 15.0531L10.5403 15.0111L9.0173 14.3231C8.95915 14.2969 8.89609 14.2833 8.8323 14.2833C8.76851 14.2833 8.70545 14.2969 8.6473 14.3231L7.2083 14.9771C6.90645 15.1139 6.56461 15.1341 6.24879 15.0336C5.93298 14.9331 5.6656 14.7192 5.4983 14.4331L5.4213 14.2801L4.8443 12.7471C4.8216 12.6878 4.78661 12.634 4.74162 12.5892C4.69664 12.5444 4.64268 12.5096 4.5833 12.4871L3.1033 11.9311C2.79257 11.8147 2.53608 11.5871 2.38349 11.2925C2.2309 10.9978 2.19306 10.657 2.2773 10.3361L2.3193 10.2061L3.0083 8.6831C3.03452 8.62495 3.04808 8.56189 3.04808 8.4981C3.04808 8.43431 3.03452 8.37125 3.0083 8.3131L2.3533 6.8741C2.21637 6.57237 2.1961 6.23061 2.29638 5.91481C2.39666 5.59901 2.61039 5.33156 2.8963 5.1641L3.0493 5.0871L4.5833 4.5091C4.64278 4.48652 4.6968 4.45158 4.74179 4.40659C4.78678 4.3616 4.82172 4.30758 4.8443 4.2481L5.4003 2.7681C5.51669 2.45758 5.74409 2.20126 6.03852 2.04869C6.33295 1.89612 6.67349 1.85814 6.9943 1.9421L7.1243 1.9841L8.6473 2.6731C8.70545 2.69932 8.76851 2.71288 8.8323 2.71288C8.89609 2.71288 8.95915 2.69932 9.0173 2.6731L10.4573 2.0191C10.759 1.88218 11.1008 1.8619 11.4166 1.96218C11.7324 2.06246 11.9998 2.27719 12.1673 2.5631ZM10.9973 6.2031L7.8103 9.8431L6.6483 8.6811C6.56387 8.60032 6.45118 8.5558 6.33434 8.55709C6.2175 8.55838 6.10581 8.60536 6.02318 8.68799C5.94056 8.77061 5.89358 8.8823 5.89229 8.99914C5.891 9.11598 5.93551 9.22867 6.0163 9.3131L7.5163 10.8131C7.55959 10.8563 7.61128 10.8901 7.66817 10.9125C7.72507 10.9349 7.78595 10.9454 7.84706 10.9434C7.90818 10.9413 7.96822 10.9267 8.02347 10.9005C8.07872 10.8744 8.12802 10.8371 8.1683 10.7911L11.6683 6.7911C11.7396 6.70113 11.7735 6.58721 11.7631 6.47291C11.7526 6.35861 11.6986 6.25271 11.6123 6.17713C11.5259 6.10155 11.4138 6.0621 11.2991 6.06693C11.1844 6.07176 11.077 6.12052 10.9973 6.2031Z" fill="#2563EB" />
                                            </svg>
                                            {item.li}
                                        </li>
                                    ))}
                                </ul>
                                <div className="grid grid-cols-2 gap-1 md:gap-2 mt-4 mb-5">
                                    {item.feature.map((item, index) => (
                                        <div className="single linear4 text-center border rounded-2xl" key={index}>
                                            <div className="inner p-3 rounded-2xl border-[#DAEAFE] bg-gradient-to-r from-[#E0EDFE] to-[rgba(224,_237,_254,_0)]">
                                                <h5 className='mb-[2px] text-primary text-base lg:text-lg xl:text-xl font-semibold leading-[150%]'>{item.title} </h5>
                                                <p className='text-sm text-[#4B5563]'>{item.p} </p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                <div className="flex justify-center">
                                    <Button 
                                        text="Access Program" 
                                        className="!p-2 !pl-3 tracking-[.046px]" 
                                        iconClass="!size-[31px]"
                                        onClick={() => setIsScheduleOpen(true)}
                                    />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5 mt-4">
                    {card2.map((item, index) => (
                        <div className="single flex flex-col gap-3 linear2 text-center bg-white rounded-2xl" key={index}>
                            <div className="inner rounded-2xl p-8">
                                <div className="icon mx-auto flex justify-center mb-5">
                                    <div dangerouslySetInnerHTML={{ __html: item.icon }} className='flex justify-center'></div>
                                </div>
                                <div>
                                    <h5 className='mb-2 text-base lg:text-lg xl:text-[28px] font-semibold text-[#1F2937] leading-[150%]'>{item.title} </h5>
                                    <p className='text-lg xl:text-xl text-[#4B5563]'>{item.p} </p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <ScheduleModal isOpen={isScheduleOpen} setIsOpen={setIsScheduleOpen} />
        </>
    )
}
